module.exports = __webpack_public_path__ + "images/7a7bf5d511930a671b94cafdfc0346a4.png";